import React from "react";
import { Droppable } from "react-beautiful-dnd";
import styled from "styled-components";
import ColumnHeader from "./ColumnHeader";
import TaskCard from "./TaskCard";

const Column = ({
  column,
  onMoveTask,
  onSubtaskComplete,
  showCompletedType,
  onToggleCompletedView,
  showGBorder,
  isAchievecolumn,
  onUpdate,
  onSubtaskDelete,
  onSubtaskReorder,
}) => {
  const itemsToShow =
    column.id === "completedList"
      ? showCompletedType === "done"
        ? column.doneItems
        : column.achievedItems
      : column.items;

  return (
    <Droppable droppableId={column.id}>
      {(provided, snapshot) => (
        <ColumnContainer
          ref={provided.innerRef}
          {...provided.droppableProps}
          isDraggingOver={snapshot.isDraggingOver}
        >
          <ColumnHeader
            column={column}
            showCompletedType={showCompletedType}
            onToggleCompletedView={onToggleCompletedView}
            showGBorder={showGBorder}
            isAchievecolumn={isAchievecolumn}
            onUpdate={onUpdate}
          />
          <TaskList>
            {itemsToShow.map((item, index) => (
              <TaskCard
                key={item.id}
                item={item}
                index={index}
                columnId={column.id}
                onMoveTask={onMoveTask}
                onSubtaskComplete={onSubtaskComplete}
                onUpdate={onUpdate}
                onSubtaskDelete={onSubtaskDelete}
                onSubtaskReorder={onSubtaskReorder}
              />
            ))}
            {provided.placeholder}
          </TaskList>
        </ColumnContainer>
      )}
    </Droppable>
  );
};

const ColumnContainer = styled.div`
  width: 317px;
  display: flex;
  flex-direction: column !important;
  gap: 12px;
  flex-shrink: 0;
  padding: 8px;
  background: #121e29;
  border-radius: 8px;
  scroll-snap-align: start;
  border: 1px solid
    ${(props) =>
      props.isDraggingOver ? "rgba(90, 155, 255, 0.5)" : "transparent"};
`;

const TaskList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 40px; // Ensures empty columns are still droppable
`;

export default Column;
